// extracted by mini-css-extract-plugin
module.exports = {"Hidden":"baltex_Hidden__jsVX8","AdminPanel":"baltex_AdminPanel__5oRy8"};